export enum GammaSpecTypeEnum {
  TIME = 'time',
  RN_DETECT = 'rnDetect',
  SCANNING = 'scanning'
}

export enum GammaSpecRnDetecModeEnum {
  LIMIT = 'limit',
  THRESHOLD = 'threshold'
}

export enum GammaSpecRnDetecUnitEnum {
  BQ_PER_KG = 'bqkg',
  BQ_PER_G = 'bqg',
  BQ_PER_L = 'bql'
}
